var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStarFill(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.55161 2.57482C9.73502 2.20323 10.2649 2.20324 10.4483 2.57482L12.4587 6.64772C12.5315 6.79514 12.6721 6.89737 12.8348 6.92115L17.3314 7.5784C17.7414 7.63832 17.9047 8.14224 17.608 8.43132L14.355 11.5997C14.2371 11.7145 14.1833 11.8801 14.2111 12.0424L14.9787 16.5178C15.0487 16.9263 14.62 17.2378 14.2531 17.0449L10.2327 14.9306C10.087 14.8539 9.91292 14.8539 9.76723 14.9306L5.74678 17.0449C5.37996 17.2378 4.95119 16.9263 5.02125 16.5178L5.78884 12.0424C5.81667 11.8801 5.76283 11.7145 5.6449 11.5997L2.39197 8.43132C2.09517 8.14224 2.25856 7.63832 2.66852 7.5784L7.16514 6.92115C7.32782 6.89737 7.46841 6.79514 7.54118 6.64772L9.55161 2.57482Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.55161 2.57482C9.73502 2.20323 10.2649 2.20324 10.4483 2.57482L12.4587 6.64772C12.5315 6.79514 12.6721 6.89737 12.8348 6.92115L17.3314 7.5784C17.7414 7.63832 17.9047 8.14224 17.608 8.43132L14.355 11.5997C14.2371 11.7145 14.1833 11.8801 14.2111 12.0424L14.9787 16.5178C15.0487 16.9263 14.62 17.2378 14.2531 17.0449L10.2327 14.9306C10.087 14.8539 9.91292 14.8539 9.76723 14.9306L5.74678 17.0449C5.37996 17.2378 4.95119 16.9263 5.02125 16.5178L5.78884 12.0424C5.81667 11.8801 5.76283 11.7145 5.6449 11.5997L2.39197 8.43132C2.09517 8.14224 2.25856 7.63832 2.66852 7.5784L7.16514 6.92115C7.32782 6.89737 7.46841 6.79514 7.54118 6.64772L9.55161 2.57482Z",
    fill: "url(#paint0_linear_1665_2461)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1665_2461",
    x1: 2.45491,
    y1: 2.63036,
    x2: 17.4748,
    y2: 19.7683,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDC82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.965761,
    stopColor: "#FFCE47"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarFill);
export default __webpack_public_path__ + "static/media/star-fill.4d2c9656341e27a7c71290011a616c6b.svg";
export { ForwardRef as ReactComponent };